import { useCallback, useMemo } from 'react';
import { utcToZone } from '../../../utils/date/utcToZone';

function getTimeFormat(value: string, resolution: string | null) {
  const d = utcToZone(value);
  switch (resolution) {
    case 'hourly':
      return d.format('HH:mm');
    case 'daily':
      return d.format('DD.MM.YY');
    case 'weekly':
      return `${d.isoWeek()}`;
    case 'monthly':
      return d.format('MM.YY');
    case 'yearly':
      return d.format('YYYY');
    default:
      return value;
  }
}

export function useChartResolutionDateFormat(resolution?: string | null) {
  const getFormat = useCallback(
    (value: string) => {
      return getTimeFormat(value, resolution || null);
    },
    [resolution],
  );
  const rotation = useMemo(() => {
    switch (resolution) {
      case 'hourly':
        return 0;
      case 'daily':
        return -45;
      case 'weekly':
        return -45;
      case 'monthly':
        return 0;
      case 'yearly':
        return 0;
      default:
        return 0;
    }
  }, [resolution]);

  return { rotation, getFormat };
}
